import React, { useEffect, useRef, useState } from "react";
import { Collapse } from "react-bootstrap";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";

function Step4Payment({
  currentStep,
  handleGoToStep,

  clientSecret,
  stripePromise,
  options,
  cartItems,
  address,
  purchaseCompleted,
  fetchClientSecret,
  email,
  setPurchaseCompleted,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef();
  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };
  useEffect(() => {
    if (purchaseCompleted) {
      handleFormSubmit();
    }
  }, [purchaseCompleted]);

  return (
    <div className="card rounded-0 border-0 checkoutCard">
      <div className="card-header border-0 d-flex justify-content-between">
        <h5
          className={`text-capitalize mb-0 fw-bold ${
            currentStep === 4 ? "" : "text-grey"
          } ${currentStep > 4 ? "text-primary-color" : ""}`}
        >
          4. Payment
        </h5>
        {currentStep > 4 ? (
          <button
            className="border-0 bg-0 text-grey"
            onClick={() => handleGoToStep(4)}
          >
            Edit
          </button>
        ) : null}
      </div>
      <Collapse in={currentStep === 4}>
        <div>
          <div className="card-body">
            {clientSecret ? (
              <Elements stripe={stripePromise} options={options}>
                <ElementsConsumer>
                  {({ stripe, elements }) => (
                    <CheckoutForm
                      ref={formRef}
                      stripe={stripe}
                      elements={elements}
                      cartItems={cartItems}
                      address={address}
                      purchaseCompleted={purchaseCompleted}
                      email={email}
                      setIsLoading={setIsLoading}
                      isSubscription
                    />
                  )}
                </ElementsConsumer>
              </Elements>
            ) : (
              <p>Loading payment details...</p>
            )}
            <div className="d-flex justify-content-between">
              {/* <button
                className="continuePaymentBtn w-100 bg-primary-color border-0 p-1 text-white w-100 mt-3"
                onClick={() => setPurchaseCompleted((prev) => !prev)}
              >
                Purchase
              </button> */}
              <button
                disabled={isLoading}
                className="continuePaymentBtn w-100 bg-primary-color border-0 p-1 text-white w-100 mt-3"
                onClick={() => setPurchaseCompleted((prev) => !prev)}
              >
                <span id="button-text">
                  {isLoading ? (
                    <svg
                      className="spinner"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
                    </svg>
                  ) : (
                    "Purchase"
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default Step4Payment;
